import {
  RecognitionAutomation,
  RecognitionAutomationInput,
  RecognitionAutomationRuleType,
  RecognitionAutomationStatus,
  RecognitionAutomationType
} from "@irati/types"

export const emptyAutomation: RecognitionAutomationInput = {
  message: "",
  walletId: "",
  occasionId: "",
  regionId: "",
  companyValueIds: [],
  companyCelebrationId: "",
  budget: {
    categoryId: "",
    useUnassigned: false
  },
  consent: false,
  rewardRules: [],
  ruleType: RecognitionAutomationRuleType.Yearly,
  recognitionAutomationStatus: RecognitionAutomationStatus.Draft,
  recognitionAutomationType: RecognitionAutomationType.Reward
}
export const getRecognitionAutomationInput = (recognitionAutomation: RecognitionAutomation): RecognitionAutomationInput => {
  return {
    message: recognitionAutomation.message,
    walletId: recognitionAutomation.walletId,
    occasionId: recognitionAutomation.occasionId,
    regionId: recognitionAutomation.region?.uuid,
    companyValueIds: recognitionAutomation.companyValueIds,
    companyCelebrationId: recognitionAutomation.companyCelebrationId,
    budget: {
      categoryId: recognitionAutomation.budget?.categoryId,
      useUnassigned: recognitionAutomation.budget?.useUnassigned
    },
    ruleType: recognitionAutomation.ruleType,
    consent: false,
    rewardRules: recognitionAutomation.rewardRules,
    recognitionAutomationStatus: recognitionAutomation.status,
    recognitionAutomationType: recognitionAutomation.automationType
  }
}
